import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1976D2',
        error: '#FF0000',
        success: '#25BA2B',
        warning: '#FF9800',
        cancel: '#BDBDBD',
        sisa: '#0078ff'
      },
    },
  },
  icons: {
    iconfont: 'md',
    iconfont: 'fa',
  },
});
